export class Promises {
  static timeout<T>(promise: Promise<T>, ms: number): Promise<T> {
    return new Promise((resolve, reject) => {
      setTimeout(() => reject(new Error(`timeout (${ms}ms)`)), ms)
      promise.then(resolve, reject)
    })
  }
}
